import { GtmEvent } from '../../enum/gtm-event';
import { UpsellKey } from '../../enum/upsell-key';
import { sanitizePathname } from '../../utils/sanitize-pathname';
import { GtmAction } from '../gtm-action';
import { GtmVariableKey } from '../gtm-variable-key';

export type UpsellClickedGtmActionPayload = {
    /** Which upsell was clicked */
    [GtmVariableKey.name]: UpsellKey;
    /** Where it was clicked, with dynamic id segments replaced by `:id`, e.g. `/orders/:id` */
    [GtmVariableKey.pathname]: string;
};

/**
 * An upsell call-to-action was clicked. Sends the current path cleaned by `sanitizePathname`, which takes
 * precedence over the raw `pathname` `useSendGTMAction` adds to every event.
 */
export class UpsellClickedGtmAction implements GtmAction {
    event = GtmEvent.upsell_clicked;

    payload: UpsellClickedGtmActionPayload;

    constructor({ name }: Pick<UpsellClickedGtmActionPayload, GtmVariableKey.name>) {
        this.payload = { name, pathname: sanitizePathname(window.location.pathname) };
    }
}
